import React from 'react';
import classNames from 'classnames';
import { IconType } from 'react-icons';

type ActionButtonIconProps = {
  'aria-hidden'?: boolean;
  className?: string;
  icon: IconType;
  badgeIcon?: IconType;
};

const ActionButtonIcon: React.FC<ActionButtonIconProps> = ({
  className,
  icon: Icon,
  badgeIcon: BadgeIcon,
}) => {
  return (
    <span
      className={classNames(
        'relative inline-flex h-[50px] w-[50px] items-center justify-center',
        className,
      )}
    >
      <Icon className="h-10 w-10" aria-hidden="true" />
      {BadgeIcon ? (
        <span className="absolute bottom-0 right-0 inline-flex h-5 w-5 items-center justify-center rounded-full bg-primary-background text-white">
          <BadgeIcon className="h-3 w-3" aria-hidden="true" />
        </span>
      ) : null}
    </span>
  );
};

export default ActionButtonIcon;
